/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-03-05 15:25:51
 * @LastEditors: wuzijia wuzijia1230@qq.com
 * @LastEditTime: 2023-05-12 17:06:13
 * @FilePath     : \youxi\youxi\src\util\openIM.js
 * @Description  : Description
 */

import { useNewIMApi, apiGameInfo } from "@/request/API";
import router from "../router";
const { VUE_APP_IM_URL } = process.env;
import sensorsTrack from "./sensorsTrack";

export const useNewIM = async (gameId = "") => {
  return useNewIMApi({
    gameId
  }).then(res => {
    return res.data;
  });
};
export const getGame = async (gameId = "") => {
  return apiGameInfo({
    id: gameId
  }).then(res => {
    return res.data;
  });
};

export const openIM = async (params = {}) => {
  const { gameId, game_id, im_type } = params;
  const id = gameId || game_id;
  const res = im_type ? { im_type } : id ? await useNewIM(id) : { im_type: 3 };
  const isOpenNewIM = res.im_type === 3;
  console.log(111, params);

  let jumpUrl = "";
  let game = {}
  //咨询客服 - 神策埋点
  if(id && !((id+'').includes('|'))) {
    game = await getGame(id);
  }
  sensorsTrack.ConsultCustomer(
    router.history.current.name,
    game.game_alias ? `${game.game_alias}_${params.shopid}` : null,
    game.game_name || '',
    game.game_id  || '',
    params.serviceId || params.id ||'',
    params.serviceName || ''
  )
  if (isOpenNewIM) {
    // 跳转新IM
    if (!params.roomId && !params.serviceId && !params.gameAlias) {
      params.gameAlias = game.game_alias
    }
    // 用户基本信息
    const { telphone, nickname, touxiang, user_id, user_sn } = JSON.parse(
      localStorage.getItem('userData') || '{}'
    );
    if (!telphone){
      return
    }
    // 主站token相关信息
    const pxToken = localStorage.getItem("token");
    const pxReToken = localStorage.getItem("refresh_token");
    const loginStatus = localStorage.getItem("loginStatus");
    const pxData = {
      pxToken,
      pxReToken,
      loginStatus,
      tel: telphone,
      name: nickname,
      avatar: touxiang,
      user_id,
      user_sn,
    };
    let _p = "";
    Object.entries(params).forEach(item => {
      _p += `&${item[0]}=${item[1]}`;
    });
    _p += `&pxdata=${JSON.stringify(pxData)}`;
    jumpUrl = `${VUE_APP_IM_URL}?tel=${telphone}${_p}`;
  } else {
    if(params.room_id || params.id){
      delete params.game_id
    }
    let routeData = router.resolve({
      name: "chatRoom",
      query: params
    });
    jumpUrl = routeData.href;
  }
  console.log(1, jumpUrl);
  jumpUrl && window.open(jumpUrl, "_blank");
};
